import { useState, useEffect } from 'react';

export const useGetUserAuthenticated = () => {
    // authenticated
    const [userAuthenticated, setUserAuthenticated] = useState(null);

    useEffect(() => {
        PULSE.app.authClient.isAuthenticated().then((isAuthenticated) => {
            setUserAuthenticated(isAuthenticated);
        });
    }, [userAuthenticated]);

    return { userAuthenticated };
};
